import Vue from "vue";
import Router from "vue-router";
import Api from "@/api/index.ts";
import checkCouponOpened from "@/services/checkCouponOpened.ts";
import store from "@/store/index";
import { setMeta } from "./setMeta";
import { routerMetaConfig } from "@/routerMetaConfig";
import vueI18n from "@/i18n";
import { urlTitle } from "@/urlTitle";

Vue.use(Router);

let langByDefault = localStorage.getItem("currentLang");
let apiLocate;
const locales = ["de", "us", "uk", "br", "es", "it", "nl", "fr"];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/styleguide",
      name: "styleguide",
      component: () =>
        import(/* webpackChunkName: "styleguide" */ "./views/Styleguide.vue"),
      meta: {
        title: "Nakarta",
        robots: () => "noindex, nofollow"
      }
    },
    {
      path: "/locale",
      name: "language",
      component: () =>
        import(/* webpackChunkName: "language" */ "./views/Language.vue"),
      meta: {
        title: "Choose your country | Nakarta",
        metaDescription: route => null,
        metaKeywords: route => null,
        robots: () => "noindex, nofollow"
      }
    },
    {
      path: "*",
      redirect: {
        path: `/:lang/`
        // path: `/${langByDefault || 'de'}/`
      },
      pathToRegexpOptions: { strict: true },
      meta: {
        title: "Nakarta",
        metaDescription: route => `Meta description `,
        metaKeywords: route => `Meta keywords `,
        robots: () =>
          process.env.NODE_ENV === "production" &&
          process.env.VUE_APP_SERVER === "prod"
            ? ""
            : "noindex, nofollow"
      }
    },
    {
      path: `/:lang/`,
      name: "home",
      pathToRegexpOptions: { strict: true },
      meta: {
        title: "Nakarta",
        metaDescription: route => `Meta description ${route.params.lang}`,
        metaKeywords: route => `Meta keywords ${route.params.lang}`,
        robots: () =>
          process.env.NODE_ENV === "production" &&
          process.env.VUE_APP_SERVER === "prod"
            ? ""
            : "noindex, nofollow"
      },
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/Home.vue"),
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: `/:lang/top`,
      name: "top",
      component: () =>
        import(/* webpackChunkName: "top" */ "./views/TopCoupons.vue"),
      meta: {
        title: route => `Coupons | Nakarta ${route.params.lang.toUpperCase()}`,
        metaDescription: route => null,
        metaKeywords: route => null,
        robots: () => "noindex, nofollow"
      }
    },
    {
      path: `/:lang/shops`,
      name: "shops",
      component: () =>
        import(/* webpackChunkName: "shops" */ "./views/Shops.vue"),
      meta: {
        title: "Nakarta",
        metaDescription: route => `Meta description shops ${route.params.lang}`,
        metaKeywords: route => `Meta keywords shops ${route.params.lang}`,
        robots: () =>
          process.env.NODE_ENV === "production" &&
          process.env.VUE_APP_SERVER === "prod"
            ? ""
            : "noindex, nofollow"
      }
    },
    {
      path: `/:lang/merchant/:id`,
      name: "merchant",
      component: () =>
        import(/* webpackChunkName: "merchant" */ "./views/Merchant.vue"),
      meta: {
        title: route => `Shops | Nakarta ${route.params.lang.toUpperCase()}`,
        metaDescription: route =>
          `Meta description merchant ${route.params.lang}`,
        metaKeywords: route => `Meta keywords merchant ${route.params.lang}`,
        robots: () => "noindex, nofollow"
      }
    },
    {
      path: `/:lang/categories/:id`,
      name: "category",
      component: () =>
        import(/* webpackChunkName: "merchant" */ "./views/Category.vue"),
      meta: {
        title: "Nakarta",
        metaDescription: route => ``,
        metaKeywords: route => ``,
        robots: () =>
          process.env.NODE_ENV === "production" &&
          process.env.VUE_APP_SERVER === "prod"
            ? ""
            : "noindex, nofollow"
      }
    },
    {
      path: `/:lang/articles/:id`,
      name: "article",
      component: () =>
        import(/* webpackChunkName: "merchant" */ "./views/Article.vue"),
      meta: {
        title: route =>
          `Interesting articles | Nakarta ${route.params.lang.toUpperCase()}`,
        metaDescription: route => null,
        metaKeywords: route => null,
        robots: () =>
          process.env.NODE_ENV === "production" &&
          process.env.VUE_APP_SERVER === "prod"
            ? ""
            : "noindex, nofollow"
      }
    },
    {
      path: `/:lang/products`,
      name: "products",
      component: () =>
        import(/* webpackChunkName: "products" */ "./views/Products.vue"),
      meta: {
        title: "Nakarta",
        metaDescription: route => ``,
        metaKeywords: route => ``,
        robots: () => "noindex, nofollow"
      }
    },
    {
      path: `/:lang/policy`,
      name: "policy",
      component: () =>
        import(/* webpackChunkName: "policy" */ "./views/static/Policy.vue"),
      meta: {
        title: "Nakarta",
        metaDescription: route => ``,
        metaKeywords: route => ``,
        robots: () => "noindex, nofollow"
      }
    },
    {
      path: `/:lang/about`,
      name: "about",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/static/About.vue"),
      meta: {
        title: "Nakarta | About us",
        metaDescription: route => ``,
        metaKeywords: route => ``,
        robots: () => "noindex, nofollow"
      }
    },
    {
      path: `/:lang/imprint`,
      name: "imprint",
      component: () =>
        import(/* webpackChunkName: "imprint" */ "./views/static/Imprint.vue"),
      meta: {
        title: "Nakarta",
        metaDescription: route => ``,
        metaKeywords: route => ``,
        robots: () => "noindex, nofollow"
      }
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  if (to.fullPath === from.fullPath && to.fullPath !== "/") return;
  if (to.name === "styleguide") {
    next();
    return;
  }
  if (to.name) {
    next();
    return;
  }
  if (!localStorage.getItem("currentLang")) {
    const { data } = await Api.getCurrentLocate();
    apiLocate = data["userRegion"].toLowerCase();
    if (apiLocate && apiLocate.match(/^(de|br|us|uk|nl|it|es|fr)$/)) {
      next();
      return;
    }
    router.push({ name: "language" });
    return;
  }
  const lang = localStorage.getItem("currentLang");
  router.push(`/${lang}/`);
  next();
  return;
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  document.title =
    typeof to.meta.title === "function" ? to.meta.title(to) : to.meta.title;
  if (to.name === "styleguide") {
    next();
    return;
  }
  if (to.name === "language") {
    next();
    return;
  }
  detectCurrentLang(to, next);
  let currentLang = localStorage.getItem("currentLang");
  if (!currentLang) {
    detectCurrentLang(to, next);
    return;
  }
  if (!to.params.lang || !to.params.lang.match(/^(de|br|us|uk|nl|it|es|fr)$/)) {
    next({ path: `/${currentLang}${to.fullPath}` });
    return;
  }
  next();
});

async function dispatchLang(param) {
  store.dispatch("app/setCurrentLang", param);
  store.dispatch("app/setLangDetected");
  checkCouponOpened();
}

let detectCurrentLang = async function(currentPage: any, nextFunction: any) {
  let storageLocate = localStorage.getItem("currentLang");
  let checkURLLocate =
    currentPage.params.lang || window.location.pathname.split("/")[1];
  if (window.location.pathname.split("/")[2] === "products") {
    if (storageLocate) {
      dispatchLang(storageLocate);
      nextFunction();
      return;
    }
  } else if (checkURLLocate.match(/^(de|br|us|uk|nl|it|es|fr)$/)) {
    dispatchLang(checkURLLocate);
  } else if (storageLocate) {
    dispatchLang(storageLocate);
    nextFunction();
    return;
  }

  const domain = window.location.hostname.split(".")[1];
  //check if it is one of regional domains
  if (domain && domain.match(/^(de|it|fr|es|nl)$/)) {
    dispatchLang(domain);
    nextFunction();
    return;
  }
  if (!apiLocate) {
    const { data } = await Api.getCurrentLocate();
    apiLocate = data["userRegion"].toLowerCase();
  }
  const currentURLChecking =
    currentPage.params.lang || window.location.pathname.split("/")[1];
  let rightURL = false;
  if (currentURLChecking.match(/^(de|br|us|uk|nl|it|es|fr)$/)) {
    apiLocate = currentURLChecking;
    rightURL = true;
  } else if (!apiLocate.match(/^(de|br|us|uk|nl|it|es|fr)$/)) {
    store.dispatch("app/setLangDetected");
    localStorage.setItem("language-open-from", currentPage.path);
    // @ts-ignore
    router.push({ name: "language" }).catch(error => {});
    return;
  }
  dispatchLang(apiLocate);
  if (!rightURL) {
    router.push({ path: `/${apiLocate}/` });
  }
  nextFunction();
};

router.beforeEach((to, from, next) => {
  if (to.name === "styleguide") {
    next();
    return;
  }
  if (!to.name) {
    next();
    return;
  }
  // @ts-ignore
  let localeObject = vueI18n._vm.messages;
  let lang = to.params.lang;
  let localeLang = to.params.lang;
  let hasLocalePage = routerMetaConfig[lang] && routerMetaConfig[lang][to.name];
  let description =
    hasLocalePage && routerMetaConfig[lang][to.name].description
      ? routerMetaConfig[lang][to.name].description
      : to.meta.metaDescription(to);
  let keywords =
    hasLocalePage && routerMetaConfig[lang][to.name].keywords
      ? routerMetaConfig[lang][to.name].keywords
      : to.meta.metaDescription(to);
  let robots = to && to.meta ? to.meta.robots() : "";
  setMeta(description, keywords, robots);

  if (to.name === "article" || to.name === "styleguide") {
    next();
    return;
  }

  if (to.name === "category") {
    let subcat = to.params.id;
    let localeKey = urlTitle[subcat];
    let localeSubcat = localeObject[localeLang][localeKey];
    document.title =
      hasLocalePage && routerMetaConfig[lang][to.name].title
        ? routerMetaConfig[lang][to.name].title(localeSubcat)
        : document.title;
    next();
    return;
  }

  if (to.name === "about" || to.name === "policy" || to.name === "imprint") {
    let aboutKey = { about: "F3", policy: "F1", imprint: "F2" }[to.name];
    let localeName = localeObject[localeLang][aboutKey];
    if (["us", "uk"].includes(localeLang) && aboutKey === "F3") {
      localeName = "About";
    }
    document.title =
      routerMetaConfig[lang] &&
      routerMetaConfig[lang].about &&
      routerMetaConfig[lang].about.title
        ? routerMetaConfig[lang].about.title(localeName)
        : document.title;
    next();
    return;
  }

  document.title =
    hasLocalePage && routerMetaConfig[lang][to.name].title
      ? routerMetaConfig[lang][to.name].title
      : document.title;
  next();
});

router.afterEach(() => {
  apiLocate = null;
});

export default router;
